import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { mapApiDeviceVendorToUiItems } from 'App/irrigation-scheduler/utils/mapApiDeviceVendorToUiItems'

export const getExternalVendorIconItems = (
  externalVendorNames: SharedTypes.IrrigationScheduler.EIrrigationVendorName[] = [],
) =>
  externalVendorNames.flatMap((vendorName) => {
    const uiItems = mapApiDeviceVendorToUiItems(vendorName)

    return uiItems.Icon ? [{ vendorName, ...uiItems }] : []
  })
